/*
 * Base is the default environment for production.
 * Add everything here and override value in other files if needed.
 * https://blog.usejournal.com/my-awesome-custom-react-environment-variables-setup-8ebb0797d8ac
 */
export default function baseEnv(baseApi) {
  return {
    route: {
      baseRoute: '/', // Fixes issue with Github Pages
    },
    api: {
      cast: `${baseApi}/shows/:showId/cast`,
      episodes: `${baseApi}/shows/:showId/episodes`,
      shows: `${baseApi}/shows/:showId`,
      getCustDetailsByCode: `${baseApi}/GetCustDetailsByCode`,
      typeDetails: `${baseApi}/TypeDetails`,
      addCustomer: `${baseApi}/AddCustomer`,
      getRateCharge: `${baseApi}/GetRemRate`,
      getBeneficiaryDetails: `${baseApi}/GetBeneficiaryDetails`,
      setCasmexAuthorize: `${baseApi}/SetCasmexAuthorize`,
      getAgentDetails: `${baseApi}/GetAgentDetails`,
      getServiceProvider: `${baseApi}/GetServiceProvider`,
      getOrganization: `${baseApi}/GetOrganization`,
      country: `${baseApi}/Country`,
      currency: `${baseApi}/Currency`,
      getIDType: `${baseApi}/GetIDType`,
      nationality: `${baseApi}/Nationality`,
      getOrgBranch: `${baseApi}/GetOrgBranch`,
      getRemitHistory: `${baseApi}/GetRemitHistory`,
      getRemitCountry: `${baseApi}/GetRemitCountry`,
      getRemitCurrency: `${baseApi}/GetRemitCurrency`,
      saveRemittance: `${baseApi}/Saveremittance`,
      getRate: `${baseApi}/Getrate`,
      getPaymentMode: `${baseApi}/GetPaymentMode`,
      addBeneficiaryUAE: `${baseApi}/AddBeneficiaryUAE`,
      getPurpose: `${baseApi}/GetPurpose`,
      getSource: `${baseApi}/GetSource`,
      getRelationShip: `${baseApi}/GetRelationship`,
      forgetPassword: `${baseApi}/ForgetPassword`,
      forgetMpin: `${baseApi}/ForgetMPIN`,
      changePassword: `${baseApi}/ChangePassword`,
      loginWthMPIN: `${baseApi}/LoginWthMPIN`,
      setCredentials: `${baseApi}/SetCredentials`,
      validateOTP: `${baseApi}/ValidateOTP`,
      generateOTP: `${baseApi}/GenerateOTP`,
      regMobile: `${baseApi}/RegMobile`,
      resetMpin: `${baseApi}/SetMpin`,
      resetPassword: `${baseApi}/SetPassword`,
      setNewPassword: `${baseApi}/setNewPassword`,
      newsEvent: `${baseApi}/GetNews`,
      services: `${baseApi}/GetRemitServiceDet`,
      getAgentDetails: `${baseApi}/GetAgentDetails`,
      getTransactionSearchByRefno: `${baseApi}/GetTransactionSearchByRefno`,
      currencyCalc: `${baseApi}/CurrencyCalc`,
      cancelTrns: `${baseApi}/CancelTrns`,
      getBankBranch: `${baseApi}/GetBankBranch`,
      uploadMedia: `${baseApi}/UploadMedia`,
      getAboutUs: `${baseApi}/GetAboutUs`,
      getDrawingBank: `${baseApi}/GetDrawingBank`,
      getProfession: `${baseApi}/GetProfession`,
      validateID: `${baseApi}/ValidateTransaction`,
      checkOTPValidity: `${baseApi}/ValidateOTP`,
    },
    isProduction: true,
    isDevelopment: false,
    isTesting: false,
  };
}
